import fr from 'facet-rest';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { advisorPage } from 'Consts/Strings';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { useCallback } from 'react';

export function missionControlURL(resource, householdId, params = {}) {
  return resource?.withRelationship(
    fr.relationships.missionControl.name,
    (rel) => buildPageLink(rel.link('related'), advisorPage, { ...params, householdId }),
    () => undefined,
  );
}
export function useMissionControlURL() {
  const { householdResource } = useSimpleHousehold();
  return useCallback((params = {}) => missionControlURL(householdResource, householdResource?.id(), params), [householdResource]);
}
